import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { authApi } from "../auth/authApi";
import logo from "../assets/img/boersenkusecpixabay.png";
import "./login.css";
import TurnstileWidget from "../components/TurnstileWidget";

export default function ResetPasswordPage() {
    const history = useHistory();
    const token = new URLSearchParams(window.location.search).get("token");

    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState("");
    const [message, setMessage] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        setError("");

        if (!turnstileToken) {
            setMessage("Bitte bestätige zuerst, dass du ein Mensch bist.");
            return;
        }

        if (!password || !passwordRepeat) {
            setError("Bitte beide Felder ausfüllen.");
            return;
        }

        if (password !== passwordRepeat) {
            setError("Die Passwörter stimmen nicht überein.");
            return;
        }

        if (!token) {
            setError("Der Reset-Link ist ungültig oder unvollständig.");
            return;
        }

        try {
            setLoading(true);
            await authApi.resetPassword(token, password);
            setDone(true);

            setTimeout(() => {
                history.push("/login");
            }, 1800);
        } catch (err) {
            setError(err.message || "Passwort konnte nicht zurückgesetzt werden.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-root">
            <div className="login-left">
                <img src={logo} alt="Logo" className="login-logo" />
                <span className="company-name">
                    Künstliche-Intelligenz-Marktanalyse-Terminal
                </span>
            </div>

            <div className="login-divider" />

            <div className="login-right">
                <h1>Neues Passwort setzen</h1>
                <p>Bitte vergeben Sie ein neues Passwort für Ihr Benutzerkonto.</p>

                {done ? (
                    <div className="login-success">
                        Ihr Passwort wurde erfolgreich zurückgesetzt. Sie werden zur Anmeldung weitergeleitet.
                    </div>
                ) : (
                    <form onSubmit={submit}>
                            <input style={{ width: "300px" }}
                            type="password"
                            placeholder="NEUES PASSWORT"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />

                            <input style={{ width: "300px" }}
                            type="password"
                            placeholder="PASSWORT WIEDERHOLEN"
                            value={passwordRepeat}
                            onChange={(e) => setPasswordRepeat(e.target.value)}
                        />

                            <TurnstileWidget style={{ width: "300px" }} onVerify={setTurnstileToken} />

                        {error && <div className="login-error">{error}</div>}

                            <button style={{ width: "300px" }} disabled={loading}>
                            {loading ? "Wird gespeichert ..." : "Passwort speichern"}
                        </button>

                        <div className="login-links">
                            <Link to="/login" className="login-link">
                                Zurück zur Anmeldung
                            </Link>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}